var zip = (function () {
    var animationClass = 'processing-animation';

    var $ready = new $.Deferred();

    var scriptAUSrc = 'https://static.zipmoney.com.au/checkout/checkout-v1.min.js';
    var scriptNZSrc = 'https://zip.co/nz/customer/assets/sandbox/partpay-sandbox-v1.js';
    var loaded = false;
    var isLocked = false;

    var setInProgress = function(value) {
        $('@zip-button').toggleClass(animationClass, value);
        isLocked = value;
    }

    var _loadZip = function () {
        if (loaded) return $ready.promise();
        loaded = true;
        var script = GlobalSettings.Iso.toUpperCase() === 'AU' ? scriptAUSrc : scriptNZSrc;
        $.getScript(script)
            .done(function () {
                var interval = setInterval(function () {
                    if (window.Zip || window.PartPay) {
                        clearInterval(interval);
                        $ready.resolve();
                    }
                }, 100);
            });
        return $ready.promise();
    }

    var _initAUZip = function (confirm) {
        var redirectUrl = location.origin + location.pathname;

        window.app && app.event && app.event.zipPayCreateOrder();

        Zip.Checkout.init({
            checkoutUri: '/api/zipservice',
            redirectUri: redirectUrl,
            onComplete: function (postdata) {
                if (postdata.state !== "approved") {
                    setInProgress(false);
                    return;
                }

                window.app && app.event && app.event.zipPayCreateCharge();

                api.createZipCharge({ data: {
                    checkoutId: postdata.checkoutId,
                    zipOrderId: postdata.checkoutId,
                    paymentStatus: postdata.state
                } }, { wait: true }).done(function(result) {
                    confirm('ZipPay', result);
                }).always(function() {
                    setInProgress(false);
                });
            }
        });
    }

    var _initNZZip = function (token, orderId, redirectUrl, confirm) {

        window.app && app.event && app.event.zipPayCreateOrder();

        PartPay.checkout({
            orderToken: {
                token: token,
                redirectUrl: redirectUrl
            },
            //forceRedirect: true,
            success: function () {
                window.app && app.event && app.event.zipPayCreateCharge();

                api.createZipCharge({
                    paymentStatus: 'success',
                    zipOrderId: orderId,
                    token: token
                }, { wait: true }).done(function(result) {
                    confirm('ZipPay', result);
                }).always(function () {
                    setInProgress(false);
                });
            },
            cancel: function () {
                setInProgress(false);
            }
        });
    }

    var _openAUZip = function (confirm) {
        _loadZip().done(function() {
            _initAUZip(confirm);
        }).fail(function () {
            setInProgress(false);
        });
    }

    var _openNZZip = function (confirm) {
        _loadZip(confirm).done(function () {
            api.getZipCheckout().done(function (data) {
                var token = data && data.Value && data.Value.Token || null;
                var redirectUrl = data && data.Value && data.Value.RedirectUrl || null;
                var orderId = data && data.Value && data.Value.OrderId || null;
                !token && setInProgress(false);
                token && _initNZZip(token, orderId, redirectUrl, confirm);
            }).fail(function () {
                setInProgress(false);
            });
        }).fail(function () {
            setInProgress(false);
        });
    }

    var buttonTmpl = '<div><img src="https://static.zipmoney.com.au/assets/default/footer-tile/footer-tile-new.png" style="height:30px;"></div>';

    var _appendAUButton = function ($el, beforePayAsync, confirm, buttonOnly) {
        var _el = buttonOnly ? $.tmpl('zip-pay-button-only') : $.tmpl('zip-pay-au-button', { merchant: 'b357ffc4-8d4f-4e55-8f43-fa5d7e1d6dfe'});
        var button = buttonOnly ? _el : _el.find('@zip-button');
        if (buttonOnly) {
            $el.replaceWith(_el);
        } else {
            _el.appendTo($el);
        }
        button.on('click', function () {
            if (isLocked) return;
            setInProgress(true);
            window.app && app.event && app.event.zipPayCreateOrder();

            var deff = beforePayAsync && beforePayAsync();
            deff && deff.done(function () {
                _openAUZip(confirm);
            }).fail(function () {
                setInProgress(false);
            });
        });
        return $el;
    };

    var _appendNZButton = function ($el, beforePayAsync, confirm, amount, buttonOnly) {
        var _el = buttonOnly ? $.tmpl('zip-pay-button-only') : $.tmpl('zip-pay-nz-button', { amount: amount });
        var button = buttonOnly ? _el : _el.find('@zip-button');
        if (buttonOnly) {
            $el.replaceWith(_el);
        } else {
            _el.appendTo($el);
        }
        button.on('click', function () {
            if (isLocked) return;
            setInProgress(true);
            window.app && app.event && app.event.zipPayCreateOrder();

            var deff = beforePayAsync && beforePayAsync();
            deff && deff.done(function() {
                _openNZZip(confirm);
            }).fail(function () {
                setInProgress(false);
            });
        });
        return $el;
    };

    var _loadZipNzInfoWidget = function (amount) {
        var zip1_info = $('#zip1 @zip-info-block');
        var deff = new $.Deferred();
        if (zip1_info.length) {
            $('#zip2 @zip-info-block').empty();
            $('#zip3 @zip-info-block').empty();
            zip1_info.html('<script async src="https://widgets.partpay.co.nz/zip-widget-classic-v3.0.0.js?min=0&max1000&amount=' + amount + '&locale=nz"></script>');

            var interval = setInterval(function () {
                if (zip1_info.find('#partPayCalculatorWidget').length > 0) {
                    clearInterval(interval);
                    deff.resolve(zip1_info.find('#partPayCalculatorWidget'), zip1_info.find('#partPayCalculatorWidgetCurtain'));
                }
            }, 100);

        } else {
            var zip_info = $('@zip-info-block').first();
            zip_info.html('<script async src="https://widgets.partpay.co.nz/zip-widget-classic-v3.0.0.js?min=0&max1000&amount=' + amount + '&locale=nz"></script>');
            deff.reject();
        }

        return deff.promise();
    }

    var _cloneZipNzInfoWidget = function (el1, el2, $toEl) {

        var clone_el1 = el1.clone();
        var clone_el2 = el2.clone();

        $toEl.empty();
        $toEl.append(clone_el1);
        $toEl.append(clone_el2);

        _subscribeZipNzInfoWidget($toEl);
    }

    var _subscribeZipNzInfoWidget = function($el) {
        $el.find('#partPayCalculatorWidget').on('click', function () {
            $el.find('#partPayCalculatorWidgetCurtain').addClass('visible');
            $el.find('#partPayCalculatorWidgetDialog').addClass('visible');
        });
        $el.find('#partPayCalculatorWidgetCurtain, .partPayCalculatorCloseButton').on('click', function () {
            $el.find('#partPayCalculatorWidgetCurtain').removeClass('visible');
            $el.find('#partPayCalculatorWidgetDialog').removeClass('visible');
        });
    }

    return {
        appendAUButton: function ($el, beforePayAsync, confirm, buttonOnly) {
            if (GlobalSettings.Iso.toUpperCase() !== 'AU') return null;
            return _appendAUButton($el, beforePayAsync, confirm, buttonOnly);
        },
        appendNZButton: function ($el, beforePayAsync, confirm, amount, buttonOnly) {
            if (GlobalSettings.Iso.toUpperCase() !== 'NZ') return null;
            return _appendNZButton($el, beforePayAsync, confirm, amount, buttonOnly);
        },
        updateAmount: function (amount) {
            _loadZipNzInfoWidget(amount).then(function (el1, el2) {
                _subscribeZipNzInfoWidget($('#zip1 @zip-info-block'));
                setTimeout(function () {
                    _cloneZipNzInfoWidget(el1, el2, $('#zip2 @zip-info-block'));
                    _cloneZipNzInfoWidget(el1, el2, $('#zip3 @zip-info-block'));
                }, 0);
            });
        }
    };


})();